/** @format */

import * as React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export default function RouterPage() {
  const { pathname } = useLocation();
  const regex =
    /\/(en|de|fr|es|it|nl|pl|de-AT|en-GB|en-IE|bg|cs|sk|hu|sr|hr|bs|da|et|fi|el|is|lv|lt|no|pt|ro|ru|sl|sv|tr|uk|de-CH)\/([^/]+)$/;
  const found = pathname.match(regex);
  if (!found) return <Redirect to={'/'} />;

  const redirectTo = pathname.replace(regex, '/$2');
  return <Redirect to={redirectTo} />;
}
